<template>
  <div class="page-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>
        <span class="page-title">定期宝</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>存币列表</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="page-content" shadow="never">
      <div class="page-actions">
        <el-select v-model="status" placeholder="状态">
          <el-option value>请选择</el-option>
          <el-option
            v-for="key in Object.keys(STATUS_TYPE)"
            :key="key"
            :label="STATUS_TYPE[key].content"
            :value="key"
          ></el-option>
        </el-select>
        <el-input placeholder="请输入用户ID" v-model="userId"></el-input>
        <el-input
          placeholder="请输入定期宝项目ID"
          v-model="pledgeId"
        ></el-input>
        <el-button @click="handleSearch" type="primary">搜索</el-button>
        <span>利息发放开关</span>
        <el-switch v-model="bigSwitch" @change="changes"></el-switch>
      </div>
      <list @refresh="getList"></list>
    </el-card>
  </div>
</template>

<script>
import './store';
import { mapState, mapActions } from 'vuex';
import List from './components/list';
import moment from 'moment';
import { STATUS_TYPE } from './constants';

export default {
  name: 'pledgeRecord',
  data() {
    return {
      STATUS_TYPE,
      userId: '',
      type: '',
      status: '',
      pledgeId: '',
      bigSwitch: '',
      types: [
        { value: '1', label: '推荐人一级奖励' },
        { value: '2', label: '推荐人二级奖励' },
        { value: '3', label: '利息奖励' }
      ]
    };
  },
  components: {
    List
  },
  computed: {
    ...mapState('pledgeCornucopia', ['projects']),
    ...mapState('pledgeRecord', ['pagination'])
  },
  methods: {
    ...mapActions('pledgeRecord', ['getRecords', 'gitSwitch', 'setSwitch']),
    ...mapActions('pledgeCornucopia', ['getList']),
    handleSearch() {
      this.getLists({
        page: 1
      });
    },
    getLists(data = {}) {
      const params = {};
      if (this.type) {
        params.type = this.type;
      }
      if (this.status) {
        params.status = this.status;
      }
      if (this.userId) {
        params.userId = this.userId;
      }
      if (this.pledgeId) {
        params.pledgeId = this.pledgeId;
      }
      this.getRecords({
        ...params,
        ...this.pagination,
        ...data
      });
    },
    changes() {
      this.setSwitch({ bigSwitch: this.bigSwitch }).then(() => {
        this.gitSwitch().then(res => {
          this.bigSwitch = res.data;
        });
      });
    }
  },
  mounted() {
    if (this.$route.query.id) {
      this.pledgeId = this.$route.query.id;
    }
    this.gitSwitch().then(res => {
      this.bigSwitch = res.data;
    });
    this.getLists();
    this.getList();
  }
};
</script>
